import loadable from '@loadable/component'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'

import componentsMap from '@/constants/componentsMap'
import store from '@/store'
import { eventDispatcher } from '@/utils/eventsHelper'
import retryDynamicImport from '@/utils/retryDynamicImport'

import ThirdPartyErrorBoundary from './ThirdPartyErrorBoundary'

const Components = ({ events, name, props, state, translations }) => {
  if (state || events) {
    useEffect(() => { eventDispatcher({ events, state, store }) }, [])
  }

  const path = componentsMap[name] || name

  const Loadable = loadable(() => retryDynamicImport(
    () => import(`@/components/${path}/index.jsx`)
  ))

  return (
    <ThirdPartyErrorBoundary>
      <Provider store={store}>
        <IntlProvider locale={window.locale} messages={translations}>
          <Loadable {...props} />
        </IntlProvider>
      </Provider>
    </ThirdPartyErrorBoundary >
  )
}

Components.propTypes = {
  events: PropTypes.array,
  name: PropTypes.string.isRequired,
  props: PropTypes.object,
  state: PropTypes.object,
  translations: PropTypes.object
}

export default Components
